<style lang="less" scoped>
@import "./index.less";
</style>

<template>

  <div class="car-plate-binding">
    <div v-for="j in carModel" class="item" @click="selectModel(j)">{{ j.name}}
    </div>
  </div>
</template>

<script>

import { IndexBar,IndexAnchor } from 'vant'
export default {
  name: 'home',
  components: {
    [IndexBar.name]: IndexBar,
    [IndexAnchor.name]:IndexAnchor,
  },
  data() {
    return {
      carModel:[]
    }
  },
  methods: {
    getCarBrandChild(b_id){
      this.$axios.post('/v3/u/carBrand/searchBrandType', {brand_id: b_id}).then(res=>{
        const children = res.data.data;
        this.carModel= (children||[]).map(item=>({name:item.name,id:item.series_id}));
      })

    },
    selectModel(item){
      this.$store.commit('carModelHandle', {id:item.id, carModelName:item.name})
      this.$router.replace({name:"carText"});
    }
  },
  mounted () {
    // 获取页面传参
    let brand_id = this.$route.query.brand_id;
    this.getCarBrandChild(brand_id)
  }
}
</script>
